module.exports = __webpack_public_path__ + "media/whatDoYouNeed3.010f3343.mp3";